import { Theme } from "@mui/material";

export const integrationStyles = {
  mainHeading: {
    fontSize: "32px",
    fontWeight: "600",
    marginBottom: "5px",
  },
  subHeading: {
    fontSize: "15px",
    fontWeight: "400",
  },
  integrationCard: (theme: Theme) => ({
    border: "1px solid #ddd",
    borderRadius: "8px",
    padding: "1rem",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    transition: "all 0.3s ease",
    "&:hover": {
      borderColor: theme.palette.primary.main,
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
      cursor: "pointer",
    },
  }),
  cardTitle: { fontSize: "17px", fontWeight: "400" },
};
